import React, { useState } from 'react'
import { Button, Snackbar } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

interface CopyToClipboardComponentProps {
  buttonText: string
  textToCopy: string
}

const CopyToClipboardComponent: React.FC<CopyToClipboardComponentProps> = ({ textToCopy, buttonText }: CopyToClipboardComponentProps) => {
  const [open, setOpen] = useState<boolean>(false)

  const copyToClipboard = (): void => {
    (navigator as any).clipboard.writeText(textToCopy)
    setOpen(true)
  }

  return (
    <>
      <Button onClick={() => { copyToClipboard() }} startIcon={<ContentCopyIcon sx={{ mr: 2 }} fontSize={'small'} />} variant={'outlined'} color={'primary'} sx={{ p: 2 }}>
        {buttonText}
      </Button>

      <Snackbar
        open={open}
        onClose={() => { setOpen(false) }}
        autoHideDuration={2000}
        message="Copied to clipboard"
      />
    </>
  )
}

export default CopyToClipboardComponent
